import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cec9b81c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sqg-createManager" }
const _hoisted_2 = { class: "sqg-createManager__content" }
const _hoisted_3 = { class: "sqg-createManager__line" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Créer l'utilisateur")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modale = _resolveComponent("Modale")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isOpen)
      ? (_openBlock(), _createBlock(_component_Modale, {
          key: 0,
          width: "30",
          height: "70",
          title: "Créer un utilisateur",
          onClose: _ctx.close
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.loader)
                ? (_openBlock(), _createBlock(_component_Loader, {
                    key: 0,
                    msg: "Création de l'utilisateur ..."
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("form", {
                class: "sqg-createManager__form",
                onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createUser && _ctx.createUser(...args)), ["prevent"]))
              }, [
                _createElementVNode("strong", null, "Identifiant utilisateur : " + _toDisplayString(_ctx.hubspotContactId), 1),
                _createVNode(_component_Input, {
                  required: "",
                  type: "text",
                  placeholder: "Prénom",
                  value: _ctx.firstname,
                  modelValue: _ctx.firstname,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstname) = $event))
                }, null, 8, ["value", "modelValue"]),
                _createVNode(_component_Input, {
                  required: "",
                  type: "text",
                  placeholder: "Nom",
                  value: _ctx.lastname,
                  modelValue: _ctx.lastname,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastname) = $event))
                }, null, 8, ["value", "modelValue"]),
                _createVNode(_component_Input, {
                  required: "",
                  type: "text",
                  placeholder: "Entreprise",
                  value: _ctx.companyName,
                  modelValue: _ctx.companyName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companyName) = $event))
                }, null, 8, ["value", "modelValue"]),
                _createVNode(_component_Input, {
                  required: "",
                  type: "text",
                  placeholder: "Adresse e-mail",
                  value: _ctx.email,
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event))
                }, null, 8, ["value", "modelValue"]),
                _createVNode(_component_Input, {
                  required: "",
                  type: "password",
                  placeholder: "Mot de passe",
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_Button, { type: "submit" }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ])
              ], 32)
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
}